module.exports = __webpack_public_path__ + "media/newstyle/images/icon-has-c90c58a653c16294ecf5d025e3bcdf87.svg";